import React, { useState } from 'react';
import cn from 'classnames';
import style from './services.mod.scss';
import Heading from '../heading/heading';
import Text from '../text/text';
import Container from '../layout/container/container';
import Divider from '../divider/divider';
import Button from '../button/button';
import Spacing from '../layout/spacing/spacing';
import { motion } from 'framer-motion';

const Services = ({
  heading,
  text,
  headingSize,
  side = 'left',
  services,
  anchor = false,
}) => {
  const [activeService, setActiveService] = useState(services[0]);

  const classes = cn(style.services, {
    [style[`services--right`]]: side === 'right',
  });

  const handleServiceChange = (service) => {
    setActiveService(service);
  };

  const variants = (i) => {
    return {
      offscreen: {
        y: 50,
        opacity: 0,
      },
      onscreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: 'spring',
          bounce: 0,
          duration: 0.5,
          delay: i / 4,
        },
      },
    };
  };

  const contentVariants = {
    offscreen: {
      opacity: 0,
    },
    onscreen: {
      opacity: 1,
      transition: {
        duration: 1,
        delay: 0.2,
      },
    },
  };

  return (
    <div id={anchor ? anchor : null}>
      <Container size="xl">
        <Divider />
        <div className={classes}>
          <div className={style.services__heading}>
            <motion.div
              variants={contentVariants}
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true, amount: 0.1 }}
            >
              <Heading text={heading} tag={2} size={headingSize} />
            </motion.div>
          </div>
          <motion.div
                variants={contentVariants}
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.1 }}
              >
          <div className={style.services__switcher}>
            <div className={style.services__titles}>
              {services.map((service, index) => (
                <div
                  key={index}
                  className={cn(style.services__title, {
                    [style['services__title--active']]:
                      activeService === service,
                  })}
                  onMouseEnter={() => handleServiceChange(service)}
                  onClick={() => handleServiceChange(service)}
                >
                  <motion.div
                    className={style.solutions__list}
                    variants={variants(index)}
                    initial="offscreen"
                    whileInView="onscreen"
                    viewport={{ once: true }}
                  >
                    <div>{service.title}</div>
                  </motion.div>
                </div>
              ))}
            </div>
            <div className={style.services__divider}></div>
            <div className={style.services__description}>
                {activeService && (
                  <>
                    <Spacing pt={2} />
                    <Text text={activeService.title} primary bold />
                    <Spacing pb={1} />
                    <Text html={activeService.paragraphText} />
                  </>
                )}
            </div>
          </div>
          </motion.div>
        </div>
      </Container>
    </div>
  );
};

export default Services;
